export enum ActiveDrawScreenState {
  DrawInfo = 1,
  AdvancedGameInstanceSettings = 2
}
